<div [formGroup]="form" class="d-flex flex-column">
  <div class="header">
    <div class="title">{{ "SHARED.OPENING_HOURS_FROM" | translate }}</div>
    <div class="title">{{ "SHARED.OPENING_HOURS_TO" | translate }}</div>
  </div>
  <div
    class="row"
    fxLayout="row wrap"
    fxLayoutAlign="start center"
    fxLayoutGap="16px"
    *ngFor="let day of DAY"
  >
    <div class="label">
      {{ DAYS + day | uppercase | translate }}
    </div>
    <app-easy-time-picker
      [formGroupName]="day"
      [hours]="hours"
      [form]="dayForm(day)"
    ></app-easy-time-picker>
    <mat-slide-toggle
      [checked]="daysEnabled[day]"
      (change)="toggleDay(day, $event)"
      color="primary"
    >
    </mat-slide-toggle>
  </div>
</div>
